module.exports = __webpack_public_path__ + "static/media/agentNotified.94258144.png";